export enum ERROR_CODE {
  INTERNAL_ERROR = 1000,
  CSRF_TOKEN_FETCHING_ERROR = 1021,
}

type Error = {
  code: ERROR_CODE;
  message: string;
  publicMessage: string;
};

type Errors = {
  [key in ERROR_CODE]: Error;
};

const INTERNAL_ERROR_PUBLIC_ERROR =
  'Internal error. Please try reloading the page. If the issue persists, get in touch with our support team.';

const errors: Errors = {
  [ERROR_CODE.INTERNAL_ERROR]: {
    code: ERROR_CODE.INTERNAL_ERROR,
    message: 'Internal error',
    publicMessage: INTERNAL_ERROR_PUBLIC_ERROR,
  },
  [ERROR_CODE.CSRF_TOKEN_FETCHING_ERROR]: {
    code: ERROR_CODE.CSRF_TOKEN_FETCHING_ERROR,
    message: 'CSRF token fetching error',
    publicMessage: INTERNAL_ERROR_PUBLIC_ERROR,
  },
};

export const createErrorMessage = (errorCode: ERROR_CODE) => `ERROR: ${errorCode} - ${errors[errorCode].publicMessage}`;
